export default function About() {
  return (
    <section id="about" className="border-t border-black/10 bg-white">
      <div className="mx-auto max-w-6xl px-4 py-16 md:py-20">
        <div className="grid gap-10 md:grid-cols-2 md:items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-semibold tracking-tight">
              A security partner you can rely on
              <span className="text-redAccent">.</span>
            </h2>
            <p className="mt-4 text-black/70 leading-relaxed">
              We provide professional security coverage for leisure and
              hospitality venues, events, retail environments, commercial sites,
              and private clients. Our approach is simple: show up prepared,
              communicate clearly, and keep people safe without creating
              unnecessary friction.
            </p>
            <p className="mt-4 text-black/70 leading-relaxed">
              Whether you need door supervisors for a busy weekend, mobile
              response for out of hours checks, CCTV monitoring for ongoing
              oversight, or discreet close protection, we tailor the team and
              plan to your environment.
            </p>

            <div className="mt-7 flex gap-3">
              <a
                href="#contact"
                className="inline-flex items-center justify-center rounded-xl bg-redAccent text-white px-5 py-3 text-sm font-medium hover:opacity-90 transition"
              >
                Speak to our team
              </a>
              <a
                href="#services"
                className="inline-flex items-center justify-center rounded-xl border border-black/15 bg-white px-5 py-3 text-sm font-medium text-black hover:border-black/30 transition"
              >
                Explore services
              </a>
            </div>
          </div>

          <div className="rounded-3xl border border-black/10 bg-white p-7 shadow-soft">
            <div className="text-sm text-black/60">What you can expect</div>
            <ul className="mt-5 space-y-4">
              {[
                "Professional conduct and a customer aware presence",
                "Strong communication with management and staff",
                "Proactive prevention, de escalation, and clear escalation pathways",
                "Accurate incident reporting and accountability",
                "Flexible coverage for single shifts or recurring contracts",
              ].map((x) => (
                <li key={x} className="flex gap-3 text-sm text-black/75">
                  <span className="mt-2 h-1.5 w-1.5 rounded-full bg-redAccent" />
                  <span>{x}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
